const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    { Header: "id", accessor: "id", width: "10%" },
    { Header: "name", accessor: "name", width: "20%" },
    { Header: "website", accessor: "webSite", width: "20%" },
    { Header: "description", accessor: "description", width: "25%" },
    { Header: "email", accessor: "email", width: "15%" },
    { Header: "Actions", accessor: "actions", width: "25%" },
  ],

  rows: [],
};

export default dataTableData;
